<template>
	<div>

		<v-row class="mb-1">
			<v-col cols="6" md="3">
				<span class="secondary-text">{{$lang.LINE_NAME}} :</span>
				<span class="sub-title-text-2"> {{line_name}}</span>
			</v-col>
			<v-col cols="6" md="3">
				<span class="secondary-text">{{$lang.LINE_ID}} :</span>
				<span class="sub-title-text-2"> {{line_unique_id}}</span>
			</v-col>
			<v-col cols="12" md="6" class="text-right">
				<span @click="addRetailer" class="cursor-pointer">
					<span class="secodry-text-4 mr-3 ">{{$lang.ADD_A_RETAILER.toUpperCase()}}</span>
					<v-btn color="primary" fab small depressed >	
						<v-icon>mdi-plus</v-icon>
					</v-btn>
				</span>
			</v-col>
		</v-row>
		<div class="mb-4 ">
			<span class="sub-title-text-2 fs-14 ">{{$lang.LIST_OF_RETAILER}}</span>
		</div>
		<!--  -->
		<div>
			<v-data-table
			:headers="headers"
			:items="retailer_list"
			:hide-default-footer="true"
			:disable-sort="true"
			:items-per-page="$keys.PAGE_LENGTH"
			class="elevation-1 custome-header-bg custome-table-body"
			:loading="table_loading"
			>

			<template v-slot:item.verification="{ item }">
				<v-icon color="#27AE60" v-if="item.is_active">
					mdi-check
				</v-icon>
				<v-icon color="error" v-else>
					mdi-window-close
				</v-icon>
			</template>	
			
			<template v-slot:item.action="{ item }">
				<v-btn small fab text @click="gotoRetailerDetails(item)">	
					<img src="@/assets/arrow-right.svg" alt="">	
				</v-btn>	
			</template>	
			<!--  empty state  -->
			<template v-slot:no-data>
				<empty-list :message="$lang.EMPTY_RETAILER" :type="$keys.EMPTY_TYPE_2"/>
			</template>	
		</v-data-table>
		<v-pagination class="custome-pagination"  v-model="page_number" :total-visible="7" :length="total_page_count"
		@input="getRetailerList"></v-pagination>


		<!-- dialogs -->
		<add-retailer-dialog :dialog="dialog" @handle-response="openDialog2"/>

		<add-form-existing-list-dialog :dialog="dialog2" :line_id="line_id" :line_name="line_name" ref="add_for_existing_list_dialog"  @update-data="getRetailerList"/>

	</div>
</div>
</template>

<script type="text/javascript">
export default {
	components: {
		AddRetailerDialog:()=>import('../retailer/child/AddRetailerDialog'),
		AddFormExistingListDialog:()=>import('../retailer/child/AddFormExistingListDialog')
	},

	data () {
		return {
			total_page_count:1,
			page_number:1,
			table_loading:false,
			line_id:"",
			line_name:"",
			line_unique_id:"",
			retailer_serch_query:"",
			retailer_list:[],
			headers: [
			{ text: 'Name', align: 'start', value: 'retailer_firm_name'},
			{ text: 'Mobile', value: 'retailer_mobile_number' },
			{ text: 'Address', value: 'retailer_full_address' },
			{ text: 'Location', value: 'retailer_location' },
			{ text: 'Verification', value: 'verification' },
			{ text: '', value: 'action' },
			],
			/* dialog for the add new  retailer*/ 
			dialog:{
				flag:false
			},
			/* for the select form existing retailers*/
			dialog2:{
				flag:false,
				line_name:"",
			}
		}
	},
	created(){
		this.line_id= this.decrypt(this.$route.params.line_id)

		this.$store.dispatch('setPageLoader', true)
		this.getRetailerList()
	},
	methods:{
		/* fetching shipment list */ 
		getRetailerList(){
			const self=this
			let params={
				page_number:this.page_number,
				page_length:this.$keys.PAGE_LENGTH,
				line_id:this.line_id,

			};
			self.table_loading=true

			const successHandler = (response) => {
				if (response.data.success){
					this.retailer_list=response.data.retailer_list
					this.line_name=response.data.line_name
					this.line_unique_id=response.data.line_id
					this.total_page_count=response.data.total_page_count

				}
			};
			const finallyHandler = () => {
				self.table_loading=false
				this.$store.dispatch('setPageLoader', false)
			};

			self.request_GET( self,self.$urls.RETAILER_LINE_DETAILS,params,successHandler,null,null,finallyHandler)
		},
		/* redirect to shipment details*/ 
		gotoRetailerDetails(item){
			this.$router.push({name:'retailer-details',params:{retailer_id:this.encript(item.retailer_id)}})
		},
		/* add retailer */
		addRetailer(){
			this.dialog.flag=true
		},
		openDialog2(){
			this.dialog2.flag=true
			this.$refs.add_for_existing_list_dialog.getRetailerList()
		}
		
	}
}


</script>